import React from 'react';
import { Modal } from '@andes/modal';
import ModalImage from './image';

export const ModalBase = ({ open, title, children, brandColor }) => {
  return (
    <Modal
      open={open}
      closable={false}
      maxWidth={0}
      srLabel=""
      type="large"
      className="modal-api-order-wrapper"
    >
      <div className="modal-api-order">
        <div className="modal-api-order__image">
          <ModalImage color={brandColor} />
        </div>

        <div className="modal-api-order__title">
          <p>{title}</p>
        </div>

        <div className="modal-api-order__actions">
          {children}
        </div>
      </div>
    </Modal>
  );
};
